export const jobRoleOptions = [
  { title: 'Broker' },
  { title: 'Borrower' },
  { title: 'Lender - Originator' },
  { title: 'Lender - Underwriter' },
];

export const emailNotificationsOptions = {
  never: 'Never',
  weekly: 'Weekly',
  daily: 'Daily',
};

export const removeAccessOption = 'removeAccess';

export const diligenceAccessLevelOptions = {
  diligence: 'Diligence',
  job: 'Job',
  [removeAccessOption]: 'Remove Access',
};

export const underwritingAccessLevelOptions = {
  edit: 'Edit',
  // view: 'View',
  [removeAccessOption]: 'Remove Access',
};
